/**
 * 引入vue,axios,
 */
import Vue from 'vue';
import axios from 'axios';
// import "babel-polyfill";
import router from '../router/index';
import {Loading, Message} from 'element-ui';
// import {rootUrl,rootUrl_37,domain} from "./rootUrl";
import * as rootUrlObj from "./rootUrl";
import { setLocal,getLocal} from '../config/utils'
axios.defaults.timeout = 60000;

/*把需要loading的请求放入arr中*/
let arr = [
  '/tmInfo/queryTrademarkArchives',
  "/tmInfo/queryTmInfoByRegNos",//多申请号查询,邱峰接口有/tm-data,文禮的沒有;
  "/tmInfo/queryTmInfoByRegNo",//单申请号查询,邱峰接口有/tm-data,文禮的沒有;
  "/tmInfo/queryTmInfoByApplicant",//申请人查询,邱峰接口有/tm-data,文禮的沒有;
  "/tmInfo/queryTmInfoById",//商标档案,邱峰接口有/tm-data,文禮的沒有;
  "/trademark/fileUpload",
  "/trademark/aiSimilarQuery",
  "/trademark/getText",
  '/payOrder/unifiedOrder',
  "/file/upload",
  "/file/uploadBase64",
  '/timestamp/getUsableNum', // 时间戳可使用服务次数
  '/timestamp/getTsAccount', // 获取用户的时间戳服务账户
  '/timestamp/insertTsAppInfo', // 创建时间戳订单
  '/timestamp/getTimeStampOrder', // 已保护文件
  '/timestamp/getTsAppInfo', // 时间戳订单
  '/timestamp/createOrderTimestamp', // 时间戳创建订单
  '/timestamp/createHashcodeAndFileId', // 时间戳上传文件
];
let loaingRequestArr = [];
/*把测试环境,正式环境等rootUrl加上*/
for (let key in rootUrlObj) {
  arr.map((item, index) => {
    loaingRequestArr.push(rootUrlObj[key] + item)
  })
}
let loadingInstance = "";
//添加一个请求拦截器
axios.interceptors.request.use(function (request) {
  let requestUrl=request.url.trim();
  var userAgent = navigator.userAgent;
  let userAgentOk = userAgent.includes("iPhone") || userAgent.includes("Nexus") || userAgent.includes("Pixel") || userAgent.includes("iPad")||userAgent.includes("Android")||userAgent.includes("SM-G900P")||true;//加上loading,暂时允许ie有loading
  if (loaingRequestArr.includes(requestUrl) && userAgentOk) {
    for (let key in handsomeLong.loading) {
      handsomeLong.loading[key].close();
    }
    handsomeLong.loading[requestUrl] = Loading.service({
      lock: false,
      text: getLocal("lang").lang == "en-US" ?"Loading":"加载中",
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.3)',
      customClass: "loading_interceptors",
    });
  } else {
  }

  const token = localStorage.getItem('token');

  if (token) {
    request.headers.Authorization = 'Bearer ' + token;
  }
  return request;
}, function (err) {
  return Promise.reject(err);
});
//添加一个响应拦截器
axios.interceptors.response.use(function (response) {
  /*非ie*/
  if (response.request.responseURL.trim() in handsomeLong.loading){
    for (let key in handsomeLong.loading) {
      handsomeLong.loading[key].close();
    }
  }
  /*ie11*/
  var userAgent = navigator.userAgent;
  let userAgentOk = userAgent.includes("Firefox") || userAgent.includes("Chrome") || userAgent.includes("Safari")||userAgent.includes("Edge");
  if(!userAgentOk){
    for (let key in handsomeLong.loading) {
      handsomeLong.loading[key].close();
    }
  }

  //响应之后对应答进行处理, 对失败的请求做统一处理,对响应时间很长的做统一处理
  switch (response.data.code) {
    case '500':
      Message('系统内部错误');
      break;
    case "400":
      Message(getLocal("lang").lang == "en-US" ? "Internal system error" : "系统内部错误");
      break;
    case "401":
      // Message(getLocal("lang").lang == "en-US" ? "Login expired, please log in again." : "登录过期,请重新登录!");
      router.push('/auth');//0814调试所需注释掉
      break;
    default:
      return response.data;
  }
}, function (err) {
  // if (err.request.responseURL.trim() in handsomeLong.loading)
  //   for (let key in handsomeLong.loading) {
  //     handsomeLong.loading[key].close();
  //   }

  if (err.response && err.response.status == 401) {
    localStorage.clear();
    router.push('/auth');//0814调试所需注释掉
  } else {
//  Message("通讯异常");
    // localStorage.clear();
    // router.push('/auth');
  }
  for (let key in handsomeLong.loading) {
    handsomeLong.loading[key].close();
  }
  return Promise.reject(err);
});


/**
 * api
 */
import {member} from "./member.js"
import {trademark} from "./trademark.js"
// import {monitoring} from "./monitoring.js"
// import {country} from "./country.js"
// import {order} from "./order.js"
import {file} from "./file.js"
import {login} from "./login.js"
import {user} from "./user.js"
// import {test} from "./test.js"
// import {tbOrder} from "./tbOrder.js"
// import {other} from "./other.js";//特殊baseUrl的api
// import {memberInvoice} from "./memberInvoice.js"
// import {applicantInfo} from "./applicantInfo.js"
import {tmInfo} from "./tmInfo.js"
// import {payment} from "./payment.js"
import {memberMessage} from "./memberMessage.js"
import {other} from "./other.js"



var $ajax = {};
Object.assign($ajax,member,trademark,file,login,user,tmInfo,memberMessage,other);
for (let key in $ajax) {
  Vue.prototype[key] = $ajax[key];
}




// WEBPACK FOOTER //
// ./src/service/index.js